import React from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteRenderOptionState } from '@mui/material';
import { Autocomplete, NoOptionsMessage } from '@routific/hive';
import DriverChip from './DriverChip';
import { DriverDtoModelType } from '../../../store/mst/models';
import DriverListItem from './DriverListItem';

interface Props {
  drivers: DriverDtoModelType[];
  value: DriverDtoModelType[];
  onChange: (drivers: DriverDtoModelType[]) => void;
}

const DriverAutocomplete: React.FC<Props> = ({ drivers, value, onChange }) => {
  const { t } = useTranslation('components');

  return (
    <Autocomplete<DriverDtoModelType>
      options={drivers}
      value={value}
      onChange={onChange}
      getOptionId={(driver) => String(driver.id)}
      getOptionLabel={(driver) => driver.name ?? ''}
      filterOptions={(opts, inputValue) => {
        if (!inputValue) return opts;
        const lowerInput = inputValue.toLowerCase();
        return opts.filter((driver) =>
          driver.name?.toLowerCase().includes(lowerInput),
        );
      }}
      placeholder={t('insights.filter.placeholder')}
      testIdPrefix="driver-selection"
      id="driver-selection-autocomplete"
      noOptionsComponent={
        <NoOptionsMessage
          title={t('insights.filter.drivers.noDriverFound')}
          subtitle={t('insights.filter.drivers.tryAnotherSearchTerm')}
        />
      }
      renderOption={(
        props: React.HTMLAttributes<HTMLLIElement> & { key: string },
        driver: DriverDtoModelType,
        state: AutocompleteRenderOptionState,
      ) => (
        <DriverListItem
          key={props.key}
          driver={driver}
          props={{ ...props, key: props.key }}
          state={state}
        />
      )}
      renderTag={(driver: DriverDtoModelType, onDelete: () => void) => (
        <DriverChip driver={driver} onDelete={onDelete} />
      )}
    />
  );
};

export default DriverAutocomplete;
